import { gql } from "@apollo/client";

export const GET_ACTIVITY_LOG = gql`
  query getActivityLog(
    $pageId: Int!
    $limit: Int!
    $activityName: String
    $dateRange: DateRangeInput
  ) {
    getActivityLog(
      filter: {
        pageId: $pageId
        limit: $limit
        activityName: $activityName
        dateRange: $dateRange
      }
    ) {
      activityLogList {
        activityLogId
        activityLogPerformerId
        activityLogName
        activityLogActionDetails
        employeeName
        isActive
        createdAt
      }
      activityLogCount
    }
  }
`;
